import React from 'react';
import { Map, List } from 'immutable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import qstorage from '../../core/storage/queries';
import FilterToggleButton from '../../components/FilterDrawer/FilterToggleButton';

/**
 * Conta filtros com valor real (ignora null, string vazia, List vazia).
 * Mesma lógica usada na tela de formaturas pra ter consistência.
 */
function countActiveFilters(filters) {
  if (!filters || typeof filters.filter !== 'function') return 0;
  return filters
    .filter((v) => {
      if (v == null) return false;
      if (typeof v === 'string') return v.trim() !== '';
      if (List.isList(v) || (v && typeof v.size === 'number')) {
        return v.size > 0;
      }
      if (Array.isArray(v)) return v.length > 0;
      return true;
    }).size;
}

/**
 * Botão do navbar que abre o drawer de filtros. Mostra badge com contagem
 * de filtros ativos. O botão "Limpar filtros" vive DENTRO do drawer (no
 * rodapé), não aqui — assim a ação de limpar fica concentrada no mesmo
 * lugar onde o usuário compõe os filtros.
 */
function FilterActions(props) {
  const { onOpen, activeCount } = props;
  return <FilterToggleButton onClick={onOpen} activeCount={activeCount} />;
}

function mapStateToProps(state, ownProps) {
  const { view, formId = 'filterForm', table = 'table' } = ownProps;
  const filterKeyPath = [table, formId, 'submit'];
  const filters = qstorage.get(state, view, filterKeyPath, Map());
  return {
    activeCount: countActiveFilters(filters),
  };
}

FilterActions.defaultProps = {
  onOpen: () => null,
  table: 'table',
  formId: 'filterForm',
  activeCount: 0,
};

FilterActions.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  view: PropTypes.string.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  formId: PropTypes.string,
  // eslint-disable-next-line react/no-unused-prop-types
  table: PropTypes.string,
  onOpen: PropTypes.func,
  activeCount: PropTypes.number,
};

export default connect(mapStateToProps)(FilterActions);
